import { Box } from '@mui/material';
import styled from 'styled-components';

export const RootContainer = styled(Box)`
  display: flex;
`;

export const MainContainer = styled(Box)`
  && {
    flex-grow: 1;
    position: relative;
    padding: 0 2rem;
    width: 100%;
    min-width: 30rem;
    /* The fixed sidebar gives this no height, and the loaders position against it. */
    min-height: 100vh;

    &:has(.maintenance-alert) {
      .ContentContainer {
        height: calc(100vh - 13rem);
      }
    }

    .merge-form {
      height: fit-content;
    }
  }
`;
